export const categoryToOption = (category) => ({
  value: category?._id || "error",
  label: category?.title || "error",
});

export const filterCategories = (inputValue, categoriesData) => {
  const filteredOptions = categoriesData
    .map(categoryToOption)
    .filter((category) =>
      category.label.toLowerCase().includes(inputValue.toLowerCase()),
    );
  return filteredOptions;
};
